import React from "react";
import "./styles.css";

const InviteIcon = ({ isActive, handleClick }) => {
  return (
    <div className="icon-container icon-margin-right" id="invite">
      <a className="icon-anchor" onClick={handleClick}>
        <svg
          className="svg-container element-icon"
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xmlSpace="preserve"
          xmlnsserif="http://www.serif.com/"
        >
          <g transform="matrix(1.79021,0,0,1.79021,53.7063,19.6923)">
            <circle className={`el-circle ${isActive ? "active" : ""}`} cx="113" cy="132" r="143" />
          </g>

          <g transform="matrix(1,0,0,1,99.5,135.625)">
            <path
              className="el-path"
              d="M39.125,29.083C35.666,29.083 32.349,30.457 29.903,32.903C27.457,35.349 26.083,38.666 26.083,42.125L26.083,198.625C26.083,202.084 27.457,205.401 29.903,207.847C32.349,210.292 35.666,211.667 39.125,211.667L273.875,211.667C277.334,211.667 280.651,210.292 283.097,207.847C285.542,205.401 286.917,202.084 286.917,198.625L286.917,42.125C286.917,38.666 285.542,35.349 283.097,32.903C280.651,30.457 277.334,29.083 273.875,29.083L39.125,29.083ZM11.459,14.459C18.797,7.122 28.748,3 39.125,3L273.875,3C284.252,3 294.203,7.122 301.54,14.459C308.878,21.797 313,31.748 313,42.125L313,198.625C313,209.002 308.878,218.953 301.54,226.29C294.203,233.628 284.252,237.75 273.875,237.75L39.125,237.75C28.748,237.75 18.797,233.628 11.459,226.29C4.122,218.953 0,209.001 0,198.625L0,42.125C0,31.748 4.122,21.797 11.459,14.459ZM182.583,68.208C182.583,61.006 188.422,55.167 195.625,55.167L221.708,55.167C232.086,55.167 242.036,59.289 249.374,66.626C256.711,73.963 260.833,83.915 260.833,94.292C260.833,104.669 256.711,114.62 249.374,121.957C245.443,125.888 240.761,128.896 235.667,130.842L258.644,165.307C262.638,171.3 261.019,179.398 255.026,183.394C249.033,187.388 240.936,185.769 236.94,179.776L208.667,137.366L208.667,172.542C208.667,179.745 202.828,185.583 195.625,185.583C188.422,185.583 182.583,179.745 182.583,172.542L182.583,68.208ZM212.811,107.333L208.667,107.333L208.667,81.25L221.708,81.25C225.167,81.25 228.485,82.624 230.93,85.07C233.375,87.516 234.75,90.833 234.75,94.292C234.75,97.75 233.375,101.068 230.93,103.513C228.485,105.959 225.167,107.333 221.708,107.333L213.192,107.333C213.066,107.332 212.939,107.332 212.811,107.333ZM77.42,63.629C74.891,56.885 67.374,53.468 60.629,55.997C53.885,58.526 50.468,66.043 52.997,72.788L92.122,177.121C94.031,182.211 98.897,185.583 104.334,185.583C109.77,185.583 114.636,182.211 116.545,177.121L155.671,72.788C158.199,66.043 154.782,58.526 148.039,55.997C141.293,53.468 133.776,56.885 131.247,63.629L104.334,135.399L77.42,63.629Z"
            />
          </g>
        </svg>
        {!isActive && (
          <div className="tooltip-btm">
            <p>Enter VR</p>
            <div className="triangle-btm"></div>
          </div>
        )}
      </a>
    </div>
  );
};
export default InviteIcon;
